<div class="alert-text-title">Alert configuration</div>
<mat-tab-group mat-align-tabs="end" (selectedTabChange)="tabChanged($event)">
  <mat-tab label="General" class="general" style="font-weight: 600">
    <div class="general-text">General alert setting when and how you want to receive email</div>
    <div class="general-row full-width top-padded">
      <div class="email-section left-padded">
        <span class="text title"> Email format </span>
        <mat-select
          class="text custom-select"
          name="emailFormatSelected"
          [value]="emailFormatSelected"
          (selectionChange)="onUserPrefsChange($event, 'emailFormatSelected')"
        >
          <mat-option *ngFor="let option of emailFormatOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </div>
      <div class="time-zone-section">
        <span class="text title"> Preferred time zone </span>
        <mat-select
          class="text custom-timezone-select"
          name="emailTimeZoneSelected"
          [value]="emailTimeZoneSelected"
          (selectionChange)="onUserPrefsChange($event, 'emailTimeZoneSelected')"
        >
          <mat-option *ngFor="let option of timeZoneOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <!-- This will is enable in futura release -->
    <div class="row full-width top-padded digest-options" *ngIf="false">
      <div class="left-padded digest-checkbox">
        <mat-checkbox
          color="primary"
          name="enableSendImmediate"
          [(ngModel)]="enableSendImmediate"
          (change)="onUserPrefsChange($event, 'enableSendImmediate')"
        ></mat-checkbox>
      </div>
      <div class="digest-content">
        <div>
          <span class="text title">Send immediately</span>
          <span class="text description">Receive an email message as soon as an event occurs</span>
        </div>
      </div>
    </div>
    <!-- This will is enable in futura release -->
    <div class="row full-width top-padded digest-options" *ngIf="false">
      <div class="left-padded digest-checkbox">
        <mat-checkbox
          color="primary"
          name="enableDailyDigest"
          [(ngModel)]="enableDailyDigest"
          (change)="onUserPrefsChange($event, 'enableDailyDigest')"
        ></mat-checkbox>
      </div>
      <div class="digest-content">
        <div>
          <span class="text title">Send a daily digest</span>
          <span class="text description">Receive one email a day for all events that occurred</span>
        </div>
        <div [ngClass]="{ slidedown: enableDailyDigest, slideup: !enableDailyDigest }">
          <span class="text title digest-time-title"
            >Choose time of day to receive daily digest email</span
          >
          <div class="row digest-time-options">
            <mat-select
              class="text"
              name="digestEmailTimeSelected"
              [value]="digestEmailTimeSelected"
              (selectionChange)="onUserPrefsChange($event, 'digestEmailTimeSelected')"
            >
              <mat-option *ngFor="let option of digestTimeOptions" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Performance" class="performance-container" *ngIf="!isGigatestDeployment()">
    <div class="toggle-container">
      <div class="performance-tab">
        <div class="performance-alert-text">Performance alerts</div>
        <div class="general-text">Select sites, applications for email notifications</div>
      </div>
      <div>
        <mat-slide-toggle
          color="primary"
          name="performanceEmailEnabled"
          [(ngModel)]="performanceEmailEnabled"
          (change)="enablePerformance($event, 'enablePerformance')"
        ></mat-slide-toggle>
      </div>
    </div>
    <div *ngIf="performanceEmailEnabled">
      <div class="show-alert">When to show alerts</div>
      <div class="Performance-container-row">
        <div class="critical-alert-container">
          <div class="show-alert">Critical alerts</div>
          <div class="alert-text">Create when they have persisted for</div>
          <div>
            <mat-select
              class="text custom-select"
              name="defaultCriticalAlert"
              [value]="defaultCriticalAlert"
              (selectionChange)="onUserAlertChange($event, 'criticalAlert')"
            >
              <mat-option *ngFor="let option of criticalAlerts" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="warning-alert-container">
          <div class="show-alert">Warning alerts</div>
          <div class="alert-text">Create when they have persisted for</div>
          <div>
            <mat-select
              class="text custom-select"
              name="defaultWarningAlert"
              [value]="defaultWarningAlert"
              (selectionChange)="onUserAlertChange($event, 'warningAlert')"
            >
              <mat-option *ngFor="let option of warningAlerts" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <nrwl-application-alerts [dataSource]="alertPreferenceSubject"></nrwl-application-alerts>
      <nrwl-site-alerts [dataSource]="alertPreferenceSubject"></nrwl-site-alerts>
      <!--hidden per OLPTC-5879-->
      <!--<nrwl-server-alerts [dataSource]="alertPreferenceSubject"></nrwl-server-alerts>-->
    </div>
  </mat-tab>
</mat-tab-group>
